import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "text-lg font-semibold" }
const _hoisted_4 = { class: "mt-2 text-gray-600" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_7 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "d-sm-flex align-items-center" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "whitespace-nowrap"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_17 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_18 = { class: "d-sm-flex align-items-center" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 2,
  class: "whitespace-nowrap"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_good_table = _resolveComponent("vue-good-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.pickupNote.note_ref), 1),
        _createElementVNode("p", _hoisted_4, [
          _cache[4] || (_cache[4] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.pickupNote.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_5, _toDisplayString(_ctx.getDate(_ctx.pickupNote.created_at)), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "border-b p-4" }, [
        _createElementVNode("h3", { class: "text-lg font-semibold" }, "Liste des nouveaux colis")
      ], -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.pickupNote.statut == 0)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewReq && _ctx.addNewReq(...args)))
              }, _cache[5] || (_cache[5] = [
                _createTextVNode(" Ajouter ", -1),
                _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm1) = $event)),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher"
          }, null, 512), [
            [_vModelText, _ctx.searchTerm1]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows1,
          "row-key": 'id',
          "select-options": {
            enabled: true,
            clearSelectionText: 'Annuler',
            selectionText: 'Demandes Sélectionées',
          },
          onSelectedRowsChange: _ctx.selectionChanged,
          onSelectAll: _ctx.onSelectAll
        }, {
          emptystate: _withCtx(() => _cache[6] || (_cache[6] = [
            _createElementVNode("div", { class: "text-center py-4 text-gray" }, " Aucune entrées correspondants trouvés ", -1)
          ])),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h6", null, _toDisplayString(props.row.magasin), 1),
                  _createElementVNode("span", null, _toDisplayString(props.row.city_name), 1)
                ], 64))
              : (props.column.field === 'note')
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(props.row.note), 1))
                : (props.column.field === 'created_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                  : (props.column.field === 'type')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (props.row.type == 'SIMPLE_PARCEL')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Colis Simple"))
                          : (props.row.type == 'SIMPLE_STOCK')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Colis Stock"))
                            : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectedRowsChange", "onSelectAll"])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "border-b p-4" }, [
        _createElementVNode("h3", { class: "text-lg font-semibold" }, "Liste des colis ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          (_ctx.pickupNote.statut == 0)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeNewReq && _ctx.removeNewReq(...args)))
              }, _cache[8] || (_cache[8] = [
                _createTextVNode(" Supprimer ", -1),
                _createElementVNode("i", { class: "flaticon-delete position-relative ms-5 fs-12" }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchTerm2) = $event)),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher"
          }, null, 512), [
            [_vModelText, _ctx.searchTerm2]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_vue_good_table, {
          "search-options": { enabled: true, externalQuery: _ctx.searchTerm2 },
          columns: _ctx.columns,
          "row-key": 'id',
          rows: _ctx.rows2,
          responsive: "",
          "select-options": {
            enabled: true,
            clearSelectionText: 'Annuler',
            selectionText: 'Demandes Sélectionées',
          },
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis
        }, {
          emptystate: _withCtx(() => _cache[9] || (_cache[9] = [
            _createElementVNode("div", { class: "text-center py-4 text-gray" }, " Aucune entrées correspondants trouvés ", -1)
          ])),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h6", null, _toDisplayString(props.row.magasin), 1),
                  _createElementVNode("span", null, _toDisplayString(props.row.city_name), 1)
                ], 64))
              : (props.column.field === 'note')
                ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(props.row.note), 1))
                : (props.column.field === 'created_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                  : (props.column.field === 'type')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (props.row.type == 'SIMPLE_PARCEL')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Colis Simple"))
                          : (props.row.type == 'SIMPLE_STOCK')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Colis Stock"))
                            : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["search-options", "columns", "rows", "onSelectAll", "onSelectedRowsChange"])
      ])
    ])
  ]))
}